import React from 'react';
import PropTypes from 'prop-types';
import {
    ERROR_BOUNDARY_SHOWN,
    withTrackComponentDisplayed,
} from './HtmlEvents';

const PixelTracking = () => {
    const PixelTrackingWithTrackComponentDisplayed = withTrackComponentDisplayed('div', ERROR_BOUNDARY_SHOWN);
    return (<PixelTrackingWithTrackComponentDisplayed />);
};

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        this.setState({
            hasError: true,
        });

        const message = error.message;
        const { protocol, host } = window.location;
        const fileName = `${protocol}://${host}/frontend-home/static-content/frontend-react.js`;
        const lineNumber = 0;
        const column = 0;

        !!window.onerror && window.onerror(message, fileName, lineNumber, column, error);
    }

    render() {
        if (this.state.hasError) {
            return (
                <>
                    <span className="odf-icon-svg odf-icon-svg-m odf-support-negative" />
                    <PixelTracking />
                </>
            );
        }

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
};
